import {
  signIn,
  signOut,
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes
} from '@aws-amplify/auth';
import React, { createContext, useEffect, useState } from "react";

export const DataContext = createContext();

// Custom hook that fetches user data and access token from Cognito
const useUserData = () => {
  const [userData, setUserData] = useState(null);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    // Fetch user data and set it in state
    const fetchData = async () => {
      try {
        const currentUser = await getCurrentUser();
        const attributes = await fetchUserAttributes();

        setUserData({
          ...currentUser,
          attributes // Aquí estarán los atributos como name, email, etc.
        });

        const session = await fetchAuthSession();
        setAccessToken(session.tokens.accessToken.toString());
      } catch (err) {
        console.log("🚀 ~ Error fetching user data:", err);
      }
    };
    fetchData();
  }, []);

  // Function that refreshes the access token on demand
  const refreshAccessToken = async () => {
    try {
      const session = await fetchAuthSession();
      setAccessToken(session.tokens.accessToken.toString());
    } catch (err) {
      console.log("🚀 ~ Error refreshing access token:", err);
    }
  };

  // Set up an interval to refresh the access token every 30 minutes
  useEffect(() => {
    const intervalId = setInterval(refreshAccessToken, 30 * 60 * 1000); // 30 minutes
    return () => clearInterval(intervalId); // Clear interval on unmount
  }, []);

  return { userData, setUserData, setAccessToken, accessToken };
};

// Context provider that provides user data and access token
export const DataProvider = ({ children }) => {
  const userDataContext = useUserData();
  return (
    <DataContext.Provider value={userDataContext}>
      {children}
    </DataContext.Provider>
  );
};
